import React, { useRef, useState } from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import {
  approveRequest,
  attachChildDucksModule,
  declineRequest
} from '../AttachChildDucks';
import { useDispatch, useSelector } from 'react-redux';
import RequesterInfo from './RequesterInfo';
import UploadFiles from './UploadFiles';
import Modal from '../../../_ui/Modal/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

export default function AttachChildDialog({ row, open, close, filter }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState('');
  const dataset = useSelector(state => state[attachChildDucksModule].data);
  const loading = useSelector(state => state[attachChildDucksModule].loading);
  const info = dataset.find(el => el.id === row['_original'].id);
  const [comment, setComment] = useState(info?.comment || '');
  const commentRef = useRef(null);

  const onApprove = () => {
    dispatch(approveRequest(info.id, filter, close));
  };
  const onDecline = () => {
    if (!comment.trim()) {
      setError(t('common_requiredField'));
      if (commentRef.current) {
        commentRef.current.focus();
      }
    } else {
      setError('');
      dispatch(declineRequest(info.id, filter, close, comment));
    }
  };
  const isDisabled = info?.status !== 'NEW';

  const handleCommentChange = e => {
    setComment(e.target.value);
    setError('');
  };
  return (
    <Modal open={open} onClose={close} title={t('attachChild_attachChild')}>
      <DialogContent className="disable">
        <RequesterInfo info={info} t={t} />
        <UploadFiles files={info?.supportingDocuments} />
        {info?.declineReason && (
          <Grid item xs={12} md={12}>
            <TextField
              value={info?.declineReason}
              label={t('attachChildColumn_reason')}
            />
          </Grid>
        )}
        {info?.status === 'NEW' && (
          <Grid item xs={12} md={12}>
            <TextField
              inputRef={commentRef}
              value={comment}
              name="comment"
              onChange={handleCommentChange}
              label={t('attachChildColumn_declineReason')}
              error={!!error}
              helperText={error}
            />
          </Grid>
        )}
      </DialogContent>
      <DialogActions style={{ textAlign: 'center' }}>
        <Button
          disabled={isDisabled}
          color="primary"
          variant="contained"
          onClick={onDecline}
          loading={loading}
        >
          {t('attachChildModal_decline')}
        </Button>
        <Button
          disabled={isDisabled}
          color="secondary"
          variant="contained"
          loading={loading}
          onClick={onApprove}
        >
          {t('attachChildModal_approve')}
        </Button>
      </DialogActions>
    </Modal>
  );
}
